// extracted by mini-css-extract-plugin
export var Header = "header-module--Header--FXXIK";
export var Header__logo = "header-module--Header__logo--1Mi_F";
export var HeaderContent = "header-module--HeaderContent--3VTJ6";
export var HeaderSection = "header-module--HeaderSection--2CyO5";